export const ROUTES = {
  LANDING: '/',
  LOGIN: '/login/',
  OTP: '/otp/',
  LOGOUT: '/logout/',
  DOCUMENTS: '/documents/',
  PROFILE: '/profile/',
  DASHBOARD: '/dashboard/',
  LOAN_DETAIL: '/loan-detail/',
  EMI_SCHEDULE: '/loan-detail/emi-schedule/',
  HISTORY: '/history/',
  PAY: '/pay',
  PAYMENT: '/payment'
}
